import { render } from "./NewAssetDialog.vue?vue&type=template&id=7363163e&scoped=true"
import script from "./NewAssetDialog.vue?vue&type=script&lang=js"
export * from "./NewAssetDialog.vue?vue&type=script&lang=js"

import "./NewAssetDialog.vue?vue&type=style&index=0&id=7363163e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7363163e"]])

export default __exports__